<template>
	<div>
        <b-alert 
            v-if="!fieldValidation.valid"
            show variant="warning"
        >
            {{ 
                $t('the-following-required-fields-are-missing-colon-{n}',
                    {
                        n: fieldValidation.fields
                    }
                ) 
            }} 
        </b-alert>
		<div v-for="formElement in parent.formElements" v-bind:key="formElement.elementid">

			<div v-if="formElement.display">

				<!-- Bool button -->
				<div v-if="formElement.type == 'bool'" class="pb-2 pt-3">
					<button
						class="btn mr-2"
						v-bind:class="[
							formElement.cssclass,
							{
								'btn-on': formElement.value,
								'btn-off': !formElement.value,
								'requiredincomplete': formElement.requiredIncomplete
							}
						]"
						v-on:click="toggleSelection(formElement, true)"
						:disabled="!canEdit(formElement)"
					>
						{{ formElement.caption }}
					</button>
					<button class="btn btn-light btn-sm ml-1 btn-xs align-top" v-if="formElement.information" v-on:click="showInfo(formElement.caption , formElement.information)">
						<b-icon icon="question"></b-icon>
					</button>
				</div>
				<!-- Select buttons -->
				<div v-if="formElement.type == 'grade'" class="form-group clear-left">
					<label v-if="formElement.caption" class="mb-0">
						{{formElement.caption}}
						<button class="btn btn-light btn-sm ml-1 btn-xs mb-1" v-if="formElement.information" v-on:click="showInfo(formElement.caption , formElement.information)">
							<b-icon icon="question"></b-icon>
						</button>
					</label>
					<p v-if="formElement.subcaption" class="small mt-0 mb-0">{{formElement.subcaption}}</p>
					<div class="btn-group" style="display: block">
						<button
							v-for="item in formElement.values"
							v-bind:key="item.value"
							class="btn"
							v-bind:class="[
								item.cssclass ,
								{
									'btn-on': formElement.value == item.value,
									'btn-off': formElement.value != item.value,
									'requiredincomplete': formElement.requiredIncomplete
								}
							]"
							v-on:click="toggleSelection(formElement, item.value)"
							:disabled="!canEdit(formElement)"
						>
							{{ item.caption }}
						</button>
					</div>
				</div>

				<!-- Ok Not Ok buttons -->
				<div v-if="formElement.type == 'oknotok'" class="form-group clear-left">
					<label v-if="formElement.caption" class="mb-0">
						{{formElement.caption}}
						<button class="btn btn-light btn-sm ml-1 btn-xs mb-1" v-if="formElement.information" v-on:click="showInfo(formElement.caption , formElement.information)">
							<b-icon icon="question"></b-icon>
						</button>
					</label>
					<div class="btn-group" style="display: block">
						<button
							class="btn btn-on-good"
							v-bind:class="{
								'btn-on': formElement.value == 1,
								'btn-off': formElement.value != 1,
								'requiredincomplete': formElement.requiredIncomplete
							}"
							v-on:click="toggleSelection(formElement, 1)"
							:disabled="!canEdit(formElement)"
						>
							{{ $t('ok') }}
						</button>
						<button
							class="btn btn-on-bad"
							v-bind:class="{
								'btn-on': formElement.value == -1,
								'btn-off': formElement.value != -1,
								'requiredincomplete': formElement.requiredIncomplete
							}"
							v-on:click="toggleSelection(formElement, -1)"
							:disabled="!canEdit(formElement)"
						>
							{{ $t('not-ok') }}
						</button>
					</div>
				</div>

				<!-- Textarea -->
				<div v-if="formElement.type == 'textarea'" class="form-group clear-left">
					<label v-if="formElement.caption" class="mb-0">
						{{formElement.caption}}
						<button class="btn btn-light btn-sm ml-1 btn-xs mb-1" v-if="formElement.information" v-on:click="showInfo(formElement.caption , formElement.information)">
							<b-icon icon="question"></b-icon>
						</button>
					</label>
					<p v-if="formElement.subcaption" class="small mt-0 mb-0">{{formElement.subcaption}}</p>
					<textarea-autosize
						v-model="formElement.value"
						class="form-control"
						:class="{'requiredincomplete': formElement.requiredIncomplete }"
						:disabled="!canEdit(formElement)"
						:placeholder="formElement.placeholder"
					></textarea-autosize>
				</div>

				<!-- Integer -->
				<div v-if="formElement.type == 'integer'" class="form-group clear-left">
					<label v-if="formElement.caption" class="mb-0">
						{{formElement.caption}}
						<button class="btn btn-light btn-sm ml-1 btn-xs mb-1" v-if="formElement.information" v-on:click="showInfo(formElement.caption , formElement.information)">
							<b-icon icon="question"></b-icon>
						</button>
					</label>
					<p v-if="formElement.subcaption" class="small mt-0 mb-0">{{formElement.subcaption}}</p>
					<b-form-input
						type="number"
						v-model="formElement.value"
						class="form-control"
						:class="{'requiredincomplete': formElement.requiredIncomplete }"
						:disabled="!canEdit(formElement)"
						:placeholder="formElement.placeholder"
						:min="formElement.min"
						:max="formElement.max"
						@blur="numberClamp"
					></b-form-input>
				</div>

			</div>

		</div>
	</div>
</template>

<script>
import FormFields from 'src/modules/forms/formfields';
export default {
	name: "treatmentsessionformelements",
	props: {
		treatmentsession: Object,
		parent: Object,
		canMark: Boolean
	},
	data() {
		return {
            FormValidator: new FormFields(),
		}
	},
	mounted() {
	},
	computed: {
		allowStudentFeedback: function(){
			if(!('id' in this.treatmentsession) || !this.treatmentsession.id){
				return true;
			}
			var secondsSinceTreatment = (Date.now() / 1000) - this.treatmentsession.treatmentTimestamp;
			var daysSinceTreatment = Math.floor(secondsSinceTreatment / (60 * 60 * 24));
			if(this.$config.getValue("lockstudentfeedbackdays")){
				if(daysSinceTreatment <= this.$config.getValue("lockstudentfeedbackdays")){
					return true;
				}
			} else {
				return true;
			}
			return false;
		},
        fieldValidation() {
            if (!this.parent?.formElements) { 
                return { valid: true, message: '', fields: '' };
            }
            return this.FormValidator.checkRequiredFields(this.parent.formElements);
        }
	},
	methods: {
		canEdit(formElement) {
			if(this.treatmentsession.isLocked && formElement.id != 'studentFeedback'){
				return false;
			}
			if('studentinput' in formElement){
				if(formElement.studentinput == true){
					if(this.$UserSession.getValue("id") == this.treatmentsession.student){
						if(this.allowStudentFeedback){
							return true;
						} else {
							return false;
						}
					} else {
						return false;
					}
				}
			}
			if(formElement.id == 'studentFeedback'){
				if(this.$UserSession.getValue("id") == this.treatmentsession.student){
					if(this.allowStudentFeedback){
						return true;
					} else {
						return false;
					}
				} else {
					return false;
				}
			}
			return this.canMark;
		},
		toggleSelection(formElement, value) {
			const newValue = formElement.value != value ? value : false;

			if (formElement.modal && newValue) {
				const modal = formElement.modal;
				if (modal.form_id) {
					this.$emit('show-form-fill', { formId: modal.form_id, formElement, value: newValue });
				} else if (modal.formresponse_id) {
					this.$emit('show-form-response', { formresponseId: modal.formresponse_id, formElement, value: newValue });
				} else {
					const self = this;
					let htmlContent = modal.content ? `<p>${modal.content}</p>` : undefined;
					if (modal.form_link) {
						const path = '/forms/' + modal.form_link + '/responses/new/stage/' + modal.form_stage;
						const href = self.$router.resolve(path).href;
						htmlContent = (modal.content ? '<p>' + modal.content + '</p>' : '')
							+ '<p><a href="' + href + '" target="_blank" rel="noopener noreferrer">' + (modal.form_label || 'Open form') + ' ↗</a></p>';
					}
					this.$store.commit("openDialog", {
						title: modal.title || '',
						htmlContent: htmlContent,
						size: modal.size || undefined,
						cancelBtn: modal.type === 'confirm',
						confirmBtnText: modal.confirmBtnText || undefined,
						cancelBtnText: modal.cancelBtnText || undefined,
						confirmCallBack: function() {
							self.$set(formElement, 'value', newValue);
						}
					});
				}
			} else {
				this.$set(formElement, 'value', newValue);
			}
		},
		showInfo: function(caption , information) {
			this.$store.commit("openDialog" , {
				cancelBtn: false ,
				title: caption,
				htmlContent: information,
				size: 'lg'
			});
		},
		numberClamp() {
			const el = event.target;
			const min = Number(el.min);
			const max = Number(el.max);

			if (el.value === '') return;

			let val = Number(el.value);
			if (val > max) val = max;
			if (val < min) val = min;

			el.value = val; // updates the DOM
		},
	},
    watch: {
        fieldValidation: {
            handler(newVal) {
                if (newVal.valid) {
                    this.$emit('validation', true);
                } else {
                    this.$emit('validation', false)
                }
            },
            deep: true,
            immediate: true
        }
    }
  
};
</script>
